import React from 'react'
import ReactDOM from 'react-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import './css/index.css'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import WebFont from 'webfontloader'
// import 'react-quill/dist/quill.snow.css'

WebFont.load({
  google: {
    families: [
      'Open+Sans:300,300i,400,400i,600,600i,700,700i,800,800i',
      'sans-serif',
      'Material Icons'
    ]
  }
})

ReactDOM.hydrate(<App />, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js